/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Fragment, useEffect, useState } from "react";
import QuizClockIcon from "../Icons/QuizClockIcon";
import Draggable from "../common/Draggable";
import { Menu, Transition } from "@headlessui/react";
import QuizArrowIcon from "../Icons/QuizArrowIcon";
import FlagIcon from "../Icons/FlagIcon";
import Calculator from "./Calculator/Calculator";
import CalculatorIcon from "../Icons/CalculatorIcon";
import CloseIcon from "../Icons/CloseIcon";
import CollectionIcon from "../Icons/CollectionIcon";
import QuizXIcon from "../Icons/QuizXIcon";
import { QuizDTO } from "../../api/Quiz/GetEssayQuizById";
import { useMutation } from "@tanstack/react-query";
import { htmlToText } from 'html-to-text';
import TimeValues from "../../assets/PV_tables.pdf";
import { Link, useParams } from "react-router-dom";
import { QuizSubmissionDTO } from "../../api/Quiz/SubmitEssayQuiz";
import { SubmitEssayQuiz } from "../../api/Quiz/SubmitEssayQuiz";
import { toast } from "react-toastify";
import ReactQuill from 'react-quill';
import PdfQuizIcon from "../Icons/PdfQuizIcon";
import QuizFolderIcon from "../Icons/QuizFolderIcon";
import 'react-quill/dist/quill.snow.css';
import Logo from "../../assets/WhiteLogo.svg"
import PostEssayQuiz from "./PostEssayQuiz";
import { EssayQuizResponse } from "../../api/Quiz/SubmitEssayQuiz";
import ReactMarkdown from "react-markdown";
import IFrameModal from "../Shared/iframeModal";
import rehypeRaw from 'rehype-raw';

const EssayQuizPage = ({ quizData, firstName, lastName }: { quizData?: QuizDTO, lastName?: string; firstName?: string; }) => {
    const modules = {
        toolbar: [
            [{ 'font': [] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean']
        ]
    };

    const { id } = useParams();
    const quizId = id || ""

    const questions = quizData?.QuestionEssay || [];
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [flaggedQuestions, setFlaggedQuestions] = useState<number[]>([]);
    const [answers, setAnswers] = useState<string[]>(Array(questions.length).fill(""));
    const [progressPercentage, setProgressPercentage] = useState(0);
    const [showCalculator, setShowCalculator] = useState(false);
    const [showUnattempted, setShowUnattempted] = useState(false);
    const [showAttempted, setShowAttempted] = useState(false);
    const [showFlagged, setShowFlagged] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false); // State to track request in progress
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [submissionResponse, setSubmissionResponse] =
        useState<EssayQuizResponse | null>(null);
        const [showPVTable, setShowPVTable] = useState(false);
        const [showTimeValues, setShowTimeValues] = useState(false);
        const [isScenarioModalOpen, setIsScenarioModalOpen] = useState(false);
        const [isModalOpen, setIsModalOpen] = useState(false);
      
    const toggleCalculator = () => {
        setShowCalculator(!showCalculator);
    };

    const handleNext = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };
    const { mutate } = useMutation({
        //@ts-expect-error
        mutationFn: (submissions) => SubmitEssayQuiz(quizId, submissions),
        onSuccess: (response: EssayQuizResponse) => {
            toast.success("Quiz submitted successfully!");
            setIsSubmitted(true);
            setIsSubmitting(false); // Set submitting status to false
            //@ts-expect-error
            setSubmissionResponse(response.data);
        },
        onError: (error) => {
            toast.error((error as any)?.response?.data?.message ?? "Failed to submit quiz.");
            console.error('Error submitting quiz:', error);
        },
    });

    useEffect(() => {
        const answeredQuestions = answers.filter(
            (answer) => answer !== ""
        ).length;
        const progress = (answeredQuestions / questions.length) * 100;
        setProgressPercentage(progress);
    }, [questions.length, answers]);

    const handleBack = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const calculateScore = () => {
        const submissions: QuizSubmissionDTO[] = [];

        questions.forEach((question, index) => {
            const answer = answers[index];
            if (answer !== "") {
                submissions.push({
                    questionId: question.id,
                    answer: htmlToText(answer, {
                        wordwrap: 130,
                    }),
                });
            }
        });

        if (submissions.length > 0) {
          setIsSubmitting(true);
          //@ts-expect-error
          mutate(submissions);
        }
        };

    const getButtonClass = (index: number) => {
        if (answers[index]) return "bg-[#4d4c4d]";
        if (index === currentQuestionIndex) return "bg-[#35540d]";
        return "bg-[#8cc63f]";
    };

    const totalTime = quizData?.duration ||  300 * questions.length;
    const [timeRemaining, setTimeRemaining] = useState(totalTime);

    const [isTimeUp, setIsTimeUp] = useState(false); // Flag to track if time is up

    useEffect(() => {
      // Set up the timer to decrement every second
      const timer = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime <= 0) {
            clearInterval(timer); // Clear the interval if the time is up
            setIsTimeUp(true);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
  
      // Clear the interval when the component unmounts
      return () => clearInterval(timer);
    }, []); // Empty dependency array means this effect runs only once on mount
  
    useEffect(() => {
      if (isTimeUp) {
        calculateScore(); // Automatically submit the quiz when time is up
      }
    }, [isTimeUp]);
      const formatTime = (time: number) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };

    const toggleFlag = () => {
        setFlaggedQuestions((prevFlags) => {
            if (prevFlags.includes(currentQuestionIndex)) {
                return prevFlags.filter((index) => index !== currentQuestionIndex);
            } else {
                return [...prevFlags, currentQuestionIndex];
            }
        });
    };

    const shouldQuestionBeVisible = (index: number) => {
        const isAttempted = answers[index] !== "";
        const isFlagged = flaggedQuestions.includes(index);

        if (showUnattempted && isAttempted) return false;
        if (showAttempted && !isAttempted) return false;
        if (showFlagged && !isFlagged) return false;

        return true;
    };

    const clearFilters = () => {
        setShowUnattempted(false);
        setShowAttempted(false);
        setShowFlagged(false);
    };



    const handleAnswerChange = (value: string) => {
        setAnswers(prevAnswers => {
            const newAnswers = [...prevAnswers];
            newAnswers[currentQuestionIndex] = value;
            return newAnswers;
        });
    };

    useEffect(() => {
        const saveCurrentAnswer = () => {
            const newAnswers = [...answers];
            newAnswers[currentQuestionIndex] = answers[currentQuestionIndex];
            setAnswers(newAnswers);
        };

        saveCurrentAnswer();
    }, [currentQuestionIndex]);

    if (isSubmitted && submissionResponse) {
        return <PostEssayQuiz courseId={`course`} lectureId={quizData?.lectureId} submissionResponse={submissionResponse} />;
    }

    return (
        <div
        id='table'
        className={`${
          showPVTable || showTimeValues ? "md:flex md:overflow-x-scroll" : ""
        }`}
      >
        <div
          className={`mx-auto max-w-5xl lg:w-[64rem] flex flex-col ${
            showPVTable || showTimeValues ? "md:min-w-[768px]" : ""
          }`}
        >
              <div className="bg-[#4d4c4d] sm:h-16 h-12 px-3 flex flex-col justify-center text-white">
                <div className="flex justify-between items-center ">
                    <div className="flex gap-2 items-center">
                        <Link to="/">
                            <img className="sm:size-12 size-8" src={Logo} alt="Logo" />
                        </Link>
                        <h1 className="md:block hidden">Question: {currentQuestionIndex + 1}</h1>
                    </div>
                    <div className="flex sm:gap-8 gap-4 items-center">
                        <button className="flex items-center gap-2">
                            <div className="sm:block hidden">
                                <QuizClockIcon height={40} width={40} />
                            </div>
                            <div>
                                <h1 className="md:block hidden">Section Time Remaining</h1>
                                <p>{formatTime(timeRemaining)}</p> {/* Dynamic time display */}
                            </div>
                        </button>
                        <div className="sm:w-32 w-24 text-center h-full">
                            <div className="overflow-hidden bg-blue-50 sm:h-3 h-2 rounded-full w-full mb-1">
                                <span
                                    className="h-full bg-[#8cc63f] block rounded-full"
                                    style={{ width: `${progressPercentage}%` }} // Dynamic width based on progress
                                ></span>
                            </div>
                            <h1 className="sm:text-base text-xs">Progress {progressPercentage.toFixed(0)}%</h1>{" "}
                            {/* Dynamic progress text */}
                        </div>
                        <button
                            className="sm:h-10 md:w-36 sm:w-[100px] h-8 w-20 text-sm  bg-[#fff8dc] text-black rounded"
                            onClick={calculateScore}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Submitting..." : "Finish Test"}
                        </button>
                    </div>
                </div>
            </div>
            <div className="h-6 bg-[#8cc63f] flex justify-between items-center px-3 text-white sm:text-base text-xs">
        <p>Test: {quizData?.title}</p>
        <p className="capitalize">Candidate: {firstName} {lastName}</p>
      </div>
      <div className="bg-white p-1 flex sm:flex-row flex-col h-[85vh]">
      <div className="sm:min-w-[71px] items-center  flex sm:flex-col gap-1 text-white w-full  sm:overflow-y-scroll sm:pr-2 pb-2 sm:overflow-x-hidden overflow-x-scroll overflow-y-hidden sm:h-auto min-h-12 sm:w-auto">
          {questions?.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentQuestionIndex(index)}
              className={`min-w-11 min-h-6 rounded flex justify-center items-center text-xs relative ${getButtonClass(
                index
              )}`}
            >
              {index + 1}
              {flaggedQuestions.includes(index) && (
                <FlagIcon className="absolute right-1" width={14} height={10} />
              )}
            </button>
          ))}
        </div>
                <div className="sm:p-6 p-3 border border-[#9EA7AC] rounded-md w-full h-full overflow-y-scroll">
                <p className="bg-[#F5F7F8] p-2.5 mb-2.5 sm:text-base text-sm">
    <ReactMarkdown className="text-justify" rehypePlugins={[rehypeRaw]}>
      {questions[currentQuestionIndex].question}
    </ReactMarkdown>
  </p>
          <div className="sm:pt-5 pb-4">
            <div className="flex flex-col items-center gap-2 mb-4">
              {questions[currentQuestionIndex].figure.map(
                (figureUrl, index) => (
                  <img
                    key={index}
                    src={figureUrl}
                    alt={`Figure ${index + 1}`}
                  />
                )
              )}
            </div>
            {questions[currentQuestionIndex].attachment ? (
                <button
                onClick={() => {
                  setShowPVTable(!showPVTable);
                  setIsScenarioModalOpen(!isScenarioModalOpen);
                }}                  
                className="p-2 mb-2.5 bg-lightGray/10 rounded-lg gap-3 flex items-center justify-center"
                >
                  <PdfQuizIcon /> Click here to view Essay Scenario{" "}
                  <QuizFolderIcon />
                </button>
            ) : (
              ""
            )}
              <button
                onClick={() => {
                  setShowTimeValues(!showTimeValues);
                  setIsModalOpen(!isModalOpen);
                }}
                className="p-2 mb-2.5 bg-lightGray/10 rounded-lg sm:gap-3 gap-1.5 flex items-center sm:text-base text-xs justify-center"
              >
                <PdfQuizIcon /> Click here to view PV Table <QuizFolderIcon />
              </button>
            <button
              onClick={toggleCalculator}
              className="items-center justify-center gap-1 bg-btnGrad py-1 border rounded px-2 sm:text-base text-xs sm:flex hidden"
            >
              <CalculatorIcon /> Calculator
            </button>
            {showCalculator && (
              <Draggable handle=".popup-header" cancel=".popup-close">
                <div className="calculator-popup">
                  <div className="popup-header">
                    Calculator{" "}
                    <span
                      className="popup-close"
                      onClick={toggleCalculator}
                      style={{ cursor: "pointer", float: "right" }}
                    >
                      <CloseIcon fill="#fff" />
                    </span>
                  </div>
                  <Calculator />
                </div>
              </Draggable>
            )}
          </div>
                    <ReactQuill
                        className="lg:h-[300px] md:h-[250px] h-[200px]"
                        theme="snow"
                        modules={modules}
                        value={answers[currentQuestionIndex]}
                        onChange={handleAnswerChange}
                    />
                </div>
            </div>
            <div>
                <div className="bg-[#4d4c4d] h-14 px-3 flex items-center justify-between text-white">
                    <Menu as="div" className="relative w-10 h-10">
                        <Menu.Button className="">
                            <CollectionIcon />
                        </Menu.Button>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="fixed w-[348px] left-0 top-0 h-full origin-top-left bg-white shadow-2xl ring-1 ring-black/5 focus:outline-none">
                                <div className="">
                                    <Menu.Item>
                                        <div className="bg-[#4d4c4d] h-16 px-3 flex items-center justify-between text-white cursor-pointer">
                                            <p>Section Review</p>
                                            <div className="bg-[#8cc63f] w-9 h-9 flex items-center justify-center rounded-full">
                                                <QuizXIcon height={20} width={20} />
                                            </div>
                                        </div>
                                    </Menu.Item>
                                    <div className="bg-[#ced8dd] p-3 relative text-black">
                                        <div>
                                            <label htmlFor="unattempted">
                                                Unattempted <input className="w-4 h-4 text-blue-600 bg-gray-400 border-gray-300 rounded focus:ring-offset-0 focus:outline-none focus:ring-0 " id="unattempted" type="checkbox" checked={showUnattempted} onChange={() => setShowUnattempted(!showUnattempted)} />
                                            </label>
                                        </div>
                                        <div>
                                            <label htmlFor="attempted">
                                                Attempted <input className="w-4 h-4 text-blue-600 bg-gray-400 border-gray-300 rounded focus:ring-offset-0 focus:outline-none focus:ring-0 " id="attempted" type="checkbox" checked={showAttempted} onChange={() => setShowAttempted(!showAttempted)} />
                                            </label>
                                        </div>
                                        <div>
                                            <label htmlFor="flagged">
                                                Flagged <input className="w-4 h-4 text-blue-600 bg-gray-400 border-gray-300 rounded focus:ring-offset-0 focus:outline-none focus:ring-0 " id="flagged" type="checkbox" checked={showFlagged} onChange={() => setShowFlagged(!showFlagged)} />
                                            </label>
                                        </div>
                                        <button className="absolute bottom-3 right-3" onClick={clearFilters}>Clear</button>
                                    </div>
                                    <Menu.Item>
                                        <div className="flex flex-wrap gap-3 mx-auto p-3">
                                            {questions.map((_, index) => {
                                                if (!shouldQuestionBeVisible(index)) {
                                                    return null;
                                                }
                                                return (
                                                    <button
                                                        key={index}
                                                        onClick={() => {
                                                            // Save current answer before changing question index
                                                            handleAnswerChange(answers[currentQuestionIndex]);
                                                            setCurrentQuestionIndex(index);
                                                        }}
                                                        className={`w-11 h-6 rounded flex justify-center items-center text-xs relative ${getButtonClass(index)}`}
                                                    >
                                                        {index + 1}
                                                        {flaggedQuestions.includes(index) && (
                                                            <FlagIcon className="absolute right-1" width={14} height={10} />
                                                        )}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </Menu.Item>
                                    <div className="bg-[#4d4c4d] h-14 px-3 flex items-center justify-between text-white absolute w-full bottom-0">
                                    </div>
                                </div>
                            </Menu.Items>
                        </Transition>
                    </Menu>
                    <div className="flex justify-end gap-2">
                        <button
                            onClick={toggleFlag}
                            className="h-10 w-10 rounded bg-[#8cc63f] text-white flex items-center gap-2 justify-center"
                        >
                            <FlagIcon />
                        </button>
                        <button
                            className="h-10 w-20 rounded bg-[#8cc63f] text-white flex items-center gap-2 justify-center"
                            onClick={handleBack}
                        >
                            <QuizArrowIcon className="rotate-180" />
                            Back
                        </button>
                        <button
                            className="h-10 w-20 rounded bg-[#8cc63f] text-white flex items-center gap-2 justify-center"
                            onClick={handleNext}
                        >
                            Next
                            <QuizArrowIcon />
                        </button>
                    </div>
                </div>
            </div>
        </div>
              <div className="w-1/2 min-w-[900px] md:block hidden">
              {showPVTable && (
                <iframe
                  src={questions[currentQuestionIndex].attachment}
                  className="w-full h-full mb-2 border rounded-lg"
                  title="PV Table"
                />
              )}
              {showTimeValues && (
                <iframe
                  src={TimeValues}
                  className="w-full h-full border rounded-lg"
                  title="Time Values"
                />
              )}
            </div>
            <IFrameModal file={TimeValues} isOpen={isModalOpen} closeModal={setIsModalOpen} />
            <IFrameModal file={questions[currentQuestionIndex].attachment} isOpen={isScenarioModalOpen} closeModal={setIsScenarioModalOpen} />
      
          </div>
      
    );
};

export default EssayQuizPage;
